/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".resize-image-modal{position:static}.resize-image-modal .edit-wrap{position:relative;padding-top:15px;max-height:600px;overflow-y:auto;overflow-x:hidden;height:600px}.resize-image-modal ig-spinner{position:absolute;left:47%;top:40%}.resize-image-modal input{display:none}.resize-image-modal img-cropper canvas{width:640px}"];
export { styles as styles };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/hub/resize.image.modal/resize.image.modal.component.scss.ngstyle.js.pre-build-optimizer.js